module.exports = __webpack_public_path__ + "img/filter_exercises.d671fb27.png";